<template>
  <div class="tab-cover-wrap ">
    <!-- <page-header heading="Organization Information" breadcrumb="Settings >> Organization Information" /> -->
    <page-header heading="Organization Information">
      <template #breadcrumb>
        <p class="text-xs">Settings >> <span style="color: #FFA600;">Organization Information</span></p>
      </template>
    </page-header>
    <div class="tab-cover">
      <Tabs />
    </div>

  </div>
</template>

<script>
import PageHeader from "@/components/Ondemand/PageHeader.vue";
// import PageHeader from "@/components/UI/NewPageHeader";

import Tabs from './Tabs.vue';

export default {
  components: {
    Tabs,
    PageHeader,
  },
 
};
</script>

<style scoped>
.tab-cover-wrap{
  /* border: 1px solid blue; */
}

.tab-cover{
   /* border: 1px solid red; */
  padding-bottom: 5%;
  margin-top: 8px;
  /* border: transparent; */
  /* border-radius: 8px; */
  /* box-shadow: 0px 0px 20px 2px #00000014; */
  width: 98.5%;
}
</style>